export default __webpack_public_path__ + "static/logo-c26f8bb288bf148cbd347fc24c03ef0a.png";